import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function unlockTripFolder(id: number) {
  return restApiClient.url(constructApiUrl(API.tripFolder.unlock.url, { id })).patch()
}
